export default {
  getters: {
    getLoad: state => state.globalLoad
  },
  mutations: {
    closeGlobalLoad(state) {
      state.globalLoad = false
    },
    openGlobalLoad(state) {
      state.globalLoad = true
    },
  },
  state: {
    globalLoad: false
  }
}
